<template>
  <div class="TwoCheckDialog">
    <transition name="dialog">
      <div
        v-if="showDialog"
        id="dialog-bg"
        @click="close($event)"
        @touchmove.prevent
        @scroll.prevent
      >
        <div id="dialog">
          <h2 style="text-align: center; font-size: 18px; padding-left: 10px">
            {{ $t(`${title}`) }}
          </h2>
          <p class="check-style">{{ $t("验证方式") }}</p>
          <div
            class="select-type"
            v-if="this.googleOp.googleTxt.trim().length != 0"
          >
            <input
              type="radio"
              name="select_type"
              :value="this.googleOp.value"
              :checked="selectType == 3"
              @change="changeType(3)"
            />&nbsp;&nbsp;{{ $t(`${googleOp.googleTxt}`) }}
          </div>
          <div
            class="select-type"
            v-if="this.mobileOp.mobileTxt.trim().length != 0"
          >
            <input
              type="radio"
              name="select_type"
              :value="this.mobileOp.value"
              :checked="selectType == 1"
              @change="changeType(1)"
            />&nbsp;&nbsp;{{ mobileOp.mobileTxt }}
          </div>
          <div
            class="select-type"
            v-if="this.emailOp.emailTxt.trim().length != 0"
          >
            <input
              type="radio"
              name="select_type"
              :value="this.emailOp.value"
              :checked="selectType == 2"
              @change="changeType(2)"
            />&nbsp;&nbsp;{{ emailOp.emailTxt }}
          </div>

          <!--          如果是短信验证，需要输入验证码-->
          <div class="sms-code">
            <input
              type="text"
              alt=""
              v-model="code"
              class="input-sms-code"
              :placeholder="$t('请输入验证码')"
            />
            <div
              class="btn-send"
              v-show="isShowSend1 && this.selectType == 1 && selectType != 3"
              @click="sendSms()"
            >
              {{ $t("发送") }}
            </div>
            <div
              class="btn-send"
              v-show="isShowSend2 && this.selectType == 2 && selectType != 3"
              @click="sendSms()"
            >
              {{ $t("发送") }}
            </div>
            <div
              class="btn-time"
              v-show="emailTime && selectType == 2 && selectType != 3"
            >
              {{ emailauth_time }}s
            </div>
            <div
              class="btn-time"
              v-show="mobileTime && selectType == 1 && selectType != 3"
            >
              {{ mobileauth_time }}s
            </div>
          </div>
          <button class="dialog-button" @click="twoFactorLogin">
            {{ $t("验证登录") }}
          </button>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { httpSendCodeByTempToken, two_factor_login } from "../api/login";
import { loginIn } from "@/utils/index";
import { Toast } from "mint-ui";
let emailauth_time = null;
let mobileauth_time = null;
export default {
  name: "TwoCheckDialog",
  props: {
    select_type: Object,
    showDialog: Boolean,
    tempToken: String,
  },
  data() {
    return {
      title: "两步验证登录",
      mobileOp: {
        value: 1,
        mobileTxt: "",
      },
      emailOp: {
        value: 2,
        emailTxt: "",
      },
      googleOp: {
        value: 3,
        googleTxt: "",
      },
      code: "",
      selectType: 1,

      // 发送按钮显示
      isShowSend1: true,
      isShowSend2: true,

      // 控制倒计时显示
      emailTime: false,
      mobileTime: false,
      emailauth_time: 0, //倒计时
      mobileauth_time: 0,
    };
  },

  mounted() {
    // 加载时完成默认选择传递数据的第一个单选
    const types = Object.keys(this.select_type);
    console.log(types);
    if (types[0] === "email") {
      this.selectType = 2;
    } else if (types[0] === "mobile") {
      this.selectType = 1;
    } else if (types[0] === "google_authenticator") {
      this.selectType = 3;
    }
  },

  methods: {
    close: function (e) {
      //获取弹窗对象
      const userCon = document.getElementById("dialog");
      if (userCon && !userCon.contains(e.target)) {
        if (emailauth_time != null) {
          clearInterval(emailauth_time);
          this.emailTime = false;
        } else if (mobileauth_time != null) {
          clearInterval(mobileauth_time);
          this.mobileTime = false;
        }
        this.$emit("closeDialog");
        this.mobileOp.mobileTxt = "";
        this.emailOp.emailTxt = "";
        this.googleOp.googleTxt = "";
        // 两部验证弹框关闭后清空缓存数据
      }
    },

    changeType(index) {
      this.isShowSend = index != 3;
      this.selectType = index;

      if (this.mobileTime) {
        this.isShowSend1 = false;
      } else if (this.emailTime) {
        this.isShowSend2 = false;
      }
      // 两部验证码独立计算发送
      // if (this.showTime) {
      //   this.showTime = false;
      //   return false;
      // } else {
      //   this.isShowSend = true;
      //   this.showTime = false;
      //   this.auth_time = 0;
      // }
    },

    // 发送验证码
    sendSms() {
      let type = "";
      if (this.selectType == 1) {
        type = "mobile";
        // 利用temp token发送验证码

        httpSendCodeByTempToken({
          temp_token: this.tempToken,
          type: type,
        }).then((res) => {
          Toast(res.msg);
          this.isShowSend1 = false;
          this.mobileTime = true;
          this.mobileauth_time = 180;

          mobileauth_time = setInterval(() => {
            this.mobileauth_time--;
            if (this.mobileauth_time <= 0) {
              this.mobileTime = false;
              this.isShowSend1 = true;

              clearInterval(mobileauth_time);
            }
          }, 1000);
        });
      } else if (this.selectType == 2) {
        type = "email";
        httpSendCodeByTempToken({
          temp_token: this.tempToken,
          type: type,
        }).then((res) => {
          Toast(res.msg);
          this.isShowSend2 = false;
          this.emailTime = true;
          this.emailauth_time = 180;

          emailauth_time = setInterval(() => {
            this.emailauth_time--;
            if (this.emailauth_time <= 0) {
              this.emailTime = false;
              this.isShowSend2 = true;
              clearInterval(emailauth_time);
            }
          }, 1000);
        });
      } else if (this.selectType == 3) {
        type = "google_authenticator";
      } else {
        Toast("请选择验证方式");
        return false;
      }
      // httpSendCodeByTempToken({
      //   temp_token: this.tempToken,
      //   type: type,
      // }).then((res) => {
      //   this.showTime = true;
      //   this.auth_time = 60;

      //   auth_timer = setInterval(() => {
      //     this.auth_time--;
      //     if (this.auth_time <= 0) {
      //       this.showTime = false;
      //       clearInterval(auth_timer);
      //     }
      //   }, 1000);
      // });
      // 利用temp token发送验证码
    },

    // 点击验证登录
    twoFactorLogin() {
      if (!this.code) {
        Toast(this.$t("请输入验证码"));
        return;
      }
      let type = "";
      if (this.selectType == 1) {
        type = "mobile";
      } else if (this.selectType == 2) {
        type = "email";
      } else if (this.selectType == 3) {
        type = "google_authenticator";
      }

      let postData = {
        code: this.code,
        temp_token: this.tempToken,
        type: type,
        device_type: "web",
      };

      // 两部验证登录
      two_factor_login(postData).then((res) => {
        if (res.code == 1) {
          //正常
          this.res = res;
          this.$store.dispatch("setToken", res.data.token);
          this.$store.dispatch("setUserInfo", res.data.user);
          if (emailauth_time != null) {
            clearInterval(emailauth_time);
            this.emailTime = false;
          } else if (mobileauth_time != null) {
            clearInterval(mobileauth_time);
            this.mobileTime = false;
          }
          this.$emit("closeDialog");
          this.code = "";
          loginIn(res.data.token);
          this.$router.replace("/index/home");
        }
      });
    },
  },

  watch: {
    select_type: {
      handler(newValue, oldValue) {
        this.select_type = newValue;
        const types = Object.keys(this.select_type);
        console.log(types);
        if (types[0] === "email") {
          this.selectType = 2;
        } else if (types[0] === "mobile") {
          this.selectType = 1;
        } else if (types[0] === "google_authenticator") {
          this.selectType = 3;
        }
        if (
          "google_authenticator" in this.select_type &&
          this.select_type.google_authenticator != -1
        ) {
          this.googleOp.googleTxt = "谷歌验证器";
        }
        if ("email" in this.select_type && this.select_type.email.length != 0) {
          // this.emailOp.emailTxt = "邮箱验证（" + this.select_type.email + ")";
          this.emailOp.emailTxt =
            this.$t("邮箱验证") + " " + "(" + this.select_type.email + ")";
          this.isShowSend1 = true;
          this.isShowSend2 = true;
        }
        if (
          "mobile" in this.select_type &&
          this.select_type.mobile.length != 0
        ) {
          this.mobileOp.mobileTxt =
            // "短信验证（" + this.select_type.mobile + ")";
            this.$t("短信验证") + " " + "(" + this.select_type.mobile + ")";
          this.isShowSend1 = true;
          this.isShowSend2 = true;
        }
      },
    },
    tempToken: {
      handler(newValue, oldValue) {
        this.tempToken = newValue;
      },
    },
    showDialog: {
      handler(newValue, oldValue) {},
    },
    deep: true,
  },

  activated() {
    if (
      "google_authenticator" in this.select_type &&
      this.select_type.google_authenticator != -1
    ) {
      this.googleOp.googleTxt = "谷歌验证器";
    }
    if ("email" in this.select_type && this.select_type.email.length != 0) {
      // this.emailOp.emailTxt = "邮箱验证（" + this.select_type.email + ")";
      this.emailOp.emailTxt =
        this.$t("邮箱验证") + " " + "(" + this.select_type.email + ")";
      this.isShowSend1 = true;
      this.isShowSend2 = true;
    }
    if ("mobile" in this.select_type && this.select_type.mobile.length != 0) {
      this.mobileOp.mobileTxt =
        // "短信验证（" + this.select_type.mobile + ")";
        this.$t("短信验证") + " " + "(" + this.select_type.mobile + ")";
      this.isShowSend1 = true;
      this.isShowSend2 = true;
    }
  },
  destroy() {},
};
</script>

<style scoped lang="less">
* {
  box-sizing: border-box;
}

#dialog-bg {
  top: 0;
  left: 0;
  position: fixed;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 98;
}

#dialog {
  border-radius: 20px 20px 0 0;
  position: fixed;
  bottom: 0;
  background-color: #ffffff;
  width: 100vw;
  padding: 15px;
  padding-bottom: 25px;

  .check-style {
    margin-top: 20px;
    line-height: 40px;
  }

  .select-type {
    line-height: 40px;
    font-size: 14px;
  }

  .select-style {
    margin-top: 10px;

    option {
      line-height: 40px;
      height: 40px;
    }
  }

  .sms-code {
    margin-top: 10px;
    overflow: hidden;

    .input-sms-code {
      height: 30px;
    }

    .btn-send {
      float: right;
      line-height: 30px;
      padding: 0 10px;
      background-color: #237acf;
      font-size: 14px;
      border-radius: 2px;
      color: white;
    }

    .btn-time {
      float: right;
      line-height: 30px;
      padding: 0 10px;
    }
  }
}

/* 适配电脑等大屏幕 */
@media (min-width: 750px) {
  #dialog {
    width: 500px;
    left: 0;
    right: 0;
    margin: 0 auto;
  }
}

.dialog-button {
  width: 100%;
  background-color: #237acf;
  border-width: 0;
  border-radius: 2px;
  margin-top: 20px;
  padding: 10px;
  outline: none;
  color: white;
}

.dialog-button:focus {
  outline: none;
}

.dialog-button:active {
  background-color: #237acf;
  border-color: #237acf;
}

.dialog-enter-active,
.dialog-leave-active {
  transition: all 0.5s;
}

.dialog-enter,
.dialog-leave-to {
  opacity: 0;
  transform: translateY(300px);
}
</style>
